import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", className = "" }) => {
  const color = variant === "dark" ? "text-slate-900" : "text-white";
  return (
    <Link to="/" data-testid="brand-logo-link" className={`inline-flex items-center gap-2 ${color} ${className}`}>
      <span className="inline-flex h-8 w-8 items-center justify-center rounded bg-blue-600">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2 20L8.5 9L12 14L15.5 7L22 20H2Z" fill="#FFFFFF" />
          <path d="M8.5 9L11 13.2L12 14L13.4 11.5L15.5 7" stroke="#2563EB" strokeWidth="0.7" />
          <path d="M13.5 11.2L14.7 12.7L16.3 11.2" stroke="#2563EB" strokeWidth="0.7" fill="none" />
          <circle cx="15.5" cy="4.5" r="1.2" fill="#FFFFFF" />
        </svg>
      </span>
      <span className="text-lg font-bold tracking-tight">Venture Nationals</span>
    </Link>
  );
};
